import { Grid } from '@material-ui/core'
import { orgSelectors } from 'ducks/orgs'
import { List } from 'elements/react-admin/List'
import { ComponentVersions_3_0, ComponentVersionsInherit } from 'opensolar-ui'
import {
  Create,
  Datagrid,
  DateInput,
  Edit,
  EditButton,
  FunctionField,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextField,
} from 'react-admin'
import { useSelector } from 'react-redux'

export const PricingScheduleActivationList = (props) => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <List hasSearch={true} {...props}>
        <Datagrid>
          <TextField source="org_name" label="Organization" />
          <TextField source="pricing_schedule_title" label="Pricing Schedule" />
          <FunctionField
            source="start_date"
            label="Start Date"
            render={(record: any) => (record.start_date ? new Date(record.start_date).toLocaleDateString() : '-')}
          />
          <FunctionField
            source="end_date"
            label="End Date"
            render={(record: any) => (record.end_date ? new Date(record.end_date).toLocaleDateString() : '-')}
          />
          <TextField source="created_by_name" label="Assigned By" />
          <FunctionField
            source="created_at"
            label="Assigned Date"
            render={(record: any) => new Date(record.created_at).toLocaleDateString()}
          />
          <EditButton useListStyle={true} />
        </Datagrid>
      </List>
    </ComponentVersionsInherit>
  )
}

const PricingScheduleActivationInputFields = (props) => {
  // Get current user's org and country from Redux
  const org = useSelector(orgSelectors.getOrg)
  const orgCountryId = org?.country?.id || null

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <ReferenceInput
          label="Pricing Schedule"
          reference="cashflow_pricing_schedules"
          source="pricing_schedule_id"
          validate={[required()]}
          fullWidth
          filter={orgCountryId ? { country: orgCountryId } : undefined}
          filterToQuery={(searchText) => ({ title__icontains: searchText })}
          perPage={1000}
        >
          <SelectInput
            source="pricing_schedule_id"
            optionText={(record: any) => `${record.title} (${record.country_iso2 || record.country_name || ''})`}
            optionValue="id"
            helperText={
              orgCountryId
                ? `Select a pricing schedule for ${org?.country?.name || "your organization's country"}`
                : 'Unable to determine organization country. Please ensure you are logged in with an organization.'
            }
          />
        </ReferenceInput>
      </Grid>
      <Grid item xs={6}>
        <DateInput
          source="start_date"
          label="Start Date"
          fullWidth
          helperText="The date from which this schedule is active (optional)"
        />
      </Grid>
      <Grid item xs={6}>
        <DateInput
          source="end_date"
          label="End Date"
          fullWidth
          helperText="The date until which this schedule is active (optional)"
        />
      </Grid>
    </Grid>
  )
}

export const PricingScheduleActivationEdit = (props) => (
  <ComponentVersionsInherit versions={ComponentVersions_3_0}>
    <Edit {...props}>
      <SimpleForm>
        <PricingScheduleActivationInputFields {...props} />
      </SimpleForm>
    </Edit>
  </ComponentVersionsInherit>
)

export const PricingScheduleActivationCreate = (props) => {
  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Create {...props}>
        <SimpleForm>
          <PricingScheduleActivationInputFields {...props} />
        </SimpleForm>
      </Create>
    </ComponentVersionsInherit>
  )
}
